module.exports = __webpack_public_path__ + "cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/cf.svg
// module id = 738
// module chunks = 0